import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {RcFormControlAbstract} from '../rc-form-control-abstract/rc-form-control-abstract';
import {Observable, ReplaySubject} from 'rxjs';

@Component({
    selector: 'lib-rc-file-input',
    template: `<div class="form-group rc-form-input" [ngClass]="{'no-description': !description}">
  <div class="title-placeholder">
    <input
      type="file"
      id="{{elementId}}"
      #fileInput
      class="form-control"
      [formControl]="control"
      attr.aria-label="{{ariaLabel}}"
      attr.aria-describedby="{{getAriaDescribedBy()}}"
      [attr.accept]="accept"
      readonly
      (focus)="onFocus()"
      (blur)="onBlur($event)"
      (change)="handleFileInput($event.target.files)"
      [attr.disabled]="_disabled == true ? true : null">

    <div role="alert" id="{{errorElementId}}" class="invalid-feedback-message" *ngIf="errorMsg">{{ errorMsg }}</div>
  </div>
</div>

`,
    styles: [`.rc-form-input{margin-top:20px;margin-bottom:20px;position:relative;transition:.3s}.rc-form-input label.input-label{position:absolute;left:12px;top:7px;transition:.3s}.rc-form-input .form-control.have-value+label{top:-25px;font-size:16px}.rc-form-input .form-control:focus+label{top:-25px;display:block;font-size:16px}`]
})

export class RcFileInputComponent extends RcFormControlAbstract implements OnInit {

    @ViewChild('fileInput') fileInput: ElementRef;

    @Input() maxlength: number;
    @Input() label: string;
    @Input() description: string;
    @Input() multiple: boolean = false;

    /**
     * max file size in MB
     */
    @Input() maxSize: number;
    @Input() fileTypes: string[] = [];
    @Input() accept: string;
    @Output() onFileChange: EventEmitter<any> = new EventEmitter();
    @Output() onFileValidationError: EventEmitter<any> = new EventEmitter();

    public openFileInput() {
        this.fileInput.nativeElement.click();
    }

    public handleFileInput(files) {
        if (files.length) {
            if (!this.multiple) {
                const file: File = files.item(0);
                if (this.maxSize) {
                    if (file.size > (this.maxSize * 1000000)) {
                        return this.handleValidationError(file);
                    }
                }
                if (this.fileTypes.length) {
                    const parts = file.name.split('.');
                    const ext = parts[parts.length - 1];
                    if (this.fileTypes.indexOf(ext.toLowerCase()) === -1) {
                        return this.handleValidationError(file);
                    }
                }
                this.readFile(file).subscribe((base64File: string) => {
                    this.onFileChange.emit({file: file, base64File: base64File});
                });

            } else {
                throw new Error('multiple not supported yet');
            }
        }
    }

    protected handleValidationError(file) {
        this.control.setValue(null);
        this.onFileValidationError.emit(file);
    }

    protected readFile(fileToRead: File): Observable<any> {
        const base64Observable = new ReplaySubject<any>();

        const fileReader = new FileReader();
        fileReader.onload = (event) => {
            base64Observable.next(fileReader.result);
        };
        fileReader.readAsDataURL(fileToRead);

        return base64Observable;
    }
}
